import { lowerCase, isEmpty } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import orderAddressOptions from '../api/orderAddressOptions'

export default {
  data () {
    return {
      currencySign: '€',
      password: '',
      passwordVerify: '',
      redeemPoints: false,
      sameShipping: true,
      isCourierAddress: '1',
      termsChecked: false,
      newsletterRegister: false,
      apcoInstallments: '0',
      piraeusInstallments: '0',
      eurobankInstallments: '0',
      minCartTotalAmountForPaidAtStore: '0',
      localErrors: {}
    }
  },
  mounted () {
    this.$store.dispatch('setAllTransporterSmartPoints', this.smartPointsData)
  },
  watch: {
    serverUseAddress (val) {
      switch (val) {
        case orderAddressOptions.shipping:
          this.sameShipping = false
          this.isCourierAddress = '1'
          break
        case orderAddressOptions.billing:
          this.sameShipping = true
          this.isCourierAddress = '1'
          break
        case orderAddressOptions.store:
          this.isCourierAddress = '0'
      }
    },
    'previewOrderData.transporterId' (val) {
      this.$store.commit('setSelectedTransporterId', val)
    },
    isCourierAddress (val) {
      if ('0' === val) {
        this.smartPointUncheck()
      }
    },
    getSmartPointIsSelected (val) {
      if (val === true) {
        this.sameShipping = true
      }
    },
    displayGiftError (val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.AdvGiftChoiceModalV2.$refs.AdvGiftChoiceGenericModal.openModal()
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'previewOrderData',
      'cartEmpty',
      'cartProductsCount',
      'cartProductsTotal',
      'getTransporters',
      'giftUserSelectionStatus',
      'getSelectedTransporterId',
      'getSmartPointIsSelected',
      'getSelectedTransporterClassName',
      'getSelectedTransporterSmartPointEnable',
      'getSelectedSmartPoint',
      'getSelectedTransporterDeliveryOptionType',
      'getIsSmartPointOnlyTransporter',
      'getSelectedTransporterSmartPointsApiError',
      'getVatError',
      'getSelectedCurrency'
    ]),
    passwordRetype () {
      return this.customerData.password === this.customerData.passwordVerify ? '' : this.t('password-retype-error')
    },
    showPointsBlocks () {
      if (!this.previewOrderData || !this.cartProductsTotal) {
        return false
      }

      if (!this.previewOrderData.loyalty.pointSystemIsEnabled) {
        return false
      }

      return this.previewOrderData.loyalty.customerTotalPoints &&
        this.previewOrderData.loyalty.customerCash > 0 &&
        this.previewOrderData.loyalty.customerCash < this.cartProductsTotal
    },
    validPayWays () {
      // here u can use ie this.customerData.country to remove option from array
      return this.previewOrderData.payWays
    },
    availableCounties () {
      if (this.customerData.country === '') {
        return {}
      }
      return this.previewOrderData.countryAndCountyData.county[this.customerData.country] || {}
    },
    availableCountiesShipping () {
      if (this.customerData.sendto_country === '') {
        return {}
      }
      return this.previewOrderData.countryAndCountyData.county[this.customerData.sendto_country] || {}
    },
    activeStores () {
      return this.previewOrderData.activeStores
    },
    orderCountry () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.country : this.customerData.sendto_country
    },
    orderCounty () {
      if (!this.isCourierAddress) {
        return ''
      }
      return this.sameShipping ? this.customerData.county : this.customerData.sendto_county
    },
    orderPostal () {
      if (!this.isCourierAddress) {
        return ''
      }
      if (this.sameShipping) {
        return this.customerData.postal === null ? '' : this.customerData.postal.replace(/\s/g, '')
      }
      return this.customerData.sendto_postal === null ? '' : this.customerData.sendto_postal.replace(/\s/g, '')
    },
    transporter () {
      return this.getTransporters.find(item => item.transporter_id === this.previewOrderData.transporterId)
    },
    transportationCost () {
      if (!this.transporter || this.previewOrderData.payWay === 'paid_at_store' || this.useAddress === orderAddressOptions.store) {
        return 0
      }
      return this.transporter.transportationCost
    },
    deliveryCost () {
      if (!this.transporter || this.previewOrderData.payWay !== 'delivery') {
        return 0
      }
      return this.transporter.deliveryCost
    },
    deliveryCostVerbal () {
      if (!this.transporter) {
        return 0
      }
      return this.transporter.deliveryCost
    },
    couponDiscount () {
      return parseFloat(this.previewOrderData.couponDiscount) || 0
    },
    orderTotal () {
      const customerPointsCash = this.redeemPoints ? this.previewOrderData.loyalty.customerCash : 0
      return this.cartProductsTotal - this.couponDiscount + this.deliveryCost + this.transportationCost - customerPointsCash
    },
    customerPointsRedeemValue () {
      if (!this.redeemPoints) {
        return 0
      }
      return this.previewOrderData ? this.previewOrderData.loyalty.customerCash.toFixed(2) : 0
    },
    useAddress () {
      if (this.isCourierAddress === '0') {
        return orderAddressOptions.store
      }

      return this.sameShipping ? orderAddressOptions.billing : orderAddressOptions.shipping
    },
    serverUseAddress () {
      return this.previewOrderData.useAddress
    },
    errors () {
      return this.previewOrderData.errors
    },
    customerData () {
      return this.previewOrderData.customerData
    },
    isCartTotalAbovePaidAtStoreMinCartTotalLimit () {
      return this.cartProductsTotal > this.previewOrderData.minCartTotalAmountForPaidAtStore
    },
    smartPointsData () {
      return this.previewOrderData.smartPointStationData
    },
    shouldDisplaySmartPoints () {
      return this.getSelectedTransporterSmartPointEnable
    },
    smartPointValidationError () {
      const logic = (
        this.getSelectedTransporterSmartPointEnable &&
        this.getIsSmartPointOnlyTransporter &&
        0 === this.getSelectedSmartPoint.id &&
        '1' === this.isCourierAddress
      ) || (
        this.getSmartPointIsSelected &&
        !this.getIsSmartPointOnlyTransporter &&
        0 === this.getSelectedSmartPoint.id &&
        '1' === this.isCourierAddress
      )
      return logic
    },
    displayLocalErrors () {
      return !isEmpty(this.localErrors)
    },
    displayGiftError () {
      return !isEmpty(this.localErrors?.gifts)
    },
    passwordRequired () {
      if (this.previewOrderData.isCustomerLoggedIn) {
        return false
      }
      return this.customerData.is_guest !== '1'
    }
  },
  methods: {
    ...mapActions(['setPreviewOrderTransporterId', 'validateVat']),
    validateForm (e) {
      this.localErrors = {}

      if (this.isCourierAddress === '0' && this.activeStores.length > 1 && !this.previewOrderData.storeId) {
        this.localErrors.store = this.t('checkout.validation.error.store')
      }

      if (this.isCourierAddress === '1' && !this.previewOrderData.transporterId) {
        this.localErrors.transporter = this.t('checkout.validation.error.transporter')
      }

      if (
        this.useAddress === orderAddressOptions.shipping &&
        (
          this.customerData.sendto_name === '' ||
          this.customerData.sendto_surname === '' ||
          this.customerData.sendto_landphone === '' ||
          this.customerData.sendto_city === '' ||
          this.customerData.sendto_postal === '' ||
          this.customerData.sendto_address === '' ||
          this.customerData.sendto_country === '' ||
          this.customerData.sendto_county === ''
        )
      ) {
        this.localErrors.shipping = this.t('checkout.validation.error.shipping')
      }

      if (
        this.previewOrderData.invoiceType === 'invoice' &&
        (
          this.previewOrderData.company_afm === '' ||
          this.previewOrderData.company_doy === '' ||
          this.previewOrderData.company_name === '' ||
          this.previewOrderData.company_address === '' ||
          this.previewOrderData.profession === ''
        )
      ) {
        this.localErrors.invoice = this.t('checkout.validation.error.invoice')
      }

      if (!this.giftsValidation()) {
        this.localErrors.gifts = 'giftsError'
      }

      if (this.smartPointValidationError) {
        this.localErrors.smartPoint = this.t('checkout.validation.error.smart_point')
      }

      if (this.payWayDeliveryComboDisallowed('paid_at_store', '2')) {
        this.localErrors.payWayDeliveryComboDisallowed = 'paidAtStoreWithCourierShipping'

        this.$toasted.error(this.t('preview.order.invalid.pay_way-delivery.combo.error', {
          params: [{
            payWayName: this.getPayWayNameByKey(),
            deliveryName: this.getDeliveryMethodNameByKey()
          }]
        }), { duration: '3500' })
      }

      const requiredEls = this.$refs.checkoutForm.querySelectorAll('[required]')
      for (const requiredEl of requiredEls) {
        const field = lowerCase(requiredEl.dataset.field_name)
        if (requiredEl.getAttribute('name') === 'accept_terms') {
          if (!requiredEl.checked) {
            this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
          }
        }
        const isFieldInvalid = requiredEl.value.trim() !== ''
        if (isFieldInvalid) {
          continue
        }
        this.localErrors[requiredEl.getAttribute('name')] = this.t('form_validation_required', { params: [{ field }] })
      }

      this.$store.commit('setCheckoutLocalErrors', this.localErrors)
      if (!this.displayLocalErrors) {
        return true
      }

      this.openValidationErrorsModal()
      e.preventDefault()
    },
    isPayWayOptionAvailable (payWayClass) {
      switch (payWayClass) {
        case 'paid_at_store':
          if (!this.isCartTotalAbovePaidAtStoreMinCartTotalLimit) {
            return false
          }
          break
        case 'delivery':
          if (this.getIsSmartPointOnlyTransporter) {
            return false
          }
          break
      }
      return true
    },
    setPayWayAfterTransporterUpdate () {
      if (this.getIsSmartPointOnlyTransporter) {
        if ('delivery' === this.previewOrderData.payWay) {
          this.previewOrderData.payWay = this.previewOrderData.payWays.filter(payWay => 'delivery' !== payWay.key)[0].key
        }
      }
    },
    setDeliveryBasedOnPayWay () {
      if (this.previewOrderData.payWay === 'paid_at_store') {
        if (this.isCourierAddress === '1') {
          this.isCourierAddress = '0'
          return
        }
      }

      if (this.previewOrderData.payWay === 'delivery') {
        if (this.isCourierAddress === '0') {
          this.isCourierAddress = '1'
        }
      }
    },
    async setTransporterId (val) {
      await this.setPreviewOrderTransporterId(val)
      this.setPayWayAfterTransporterUpdate()
    },
    giftsValidation () {
      if (this.giftUserSelectionStatus.invalid) {
        const invalidChoiceBase = this.t(
          'action.submit.status.invalid',
          { namespace: 'giftSelection' }
        )
        const invalidChoiceReason = this.t(
          `action.submit.status.${this.giftUserSelectionStatus.statusKey}`,
          { namespace: 'giftSelection' }
        )
        this.$toasted.error(`${invalidChoiceBase} ${invalidChoiceReason}`, { duration: 2500 })
        this.jQuery('#GiftChoiceModal').modal('show')
        return false
      }
      this.jQuery('#GiftChoiceModal').modal('hide')
      return true
    },
    smartPointUncheck () {
      this.$store.dispatch('smartPointUncheck')
    },
    getPayWayNameByKey () {
      const payWayKey = this.previewOrderData.payWay
      return this.validPayWays.find(payWay => payWay.key === payWayKey).value
    },
    getDeliveryMethodNameByKey () {
      const deliveryMethodKey = this.useAddress
      switch (deliveryMethodKey) {
        case '0':
          return this.t('preview.order.send.by.courier')
        case '1':
          return this.t('preview.order.send.by.courier')
        case '2':
          return this.t('preview.order.pickup.at.store')
      }
    },
    payWayDeliveryComboDisallowed (payWay, useAddress) {
      return this.previewOrderData.payWay === payWay && this.useAddress !== useAddress
    },
    openValidationErrorsModal () {
      this.$nextTick(() => {
        if (!this.displayGiftError) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          this.$refs.CheckoutErrorsModal.openModal()
          return
        }
        this.$refs.AdvGiftChoiceModalV2.$refs.AdvGiftChoiceGenericModal.openModal()
      })
    }
  }
}
